// extracted by css-extract-rspack-plugin
export default {"base":"Pdc4z_","outlined":"VnIv3M","text":"g5EbIR","triggerLabel":"Za2SJ_","triggerIcon":"YzmAyY","checkIcon":"CRTQjT","group":"HzVueG","drawerSpacer":"m6q19Q"};